export const findParent = (parent, id) => {
  if (!id) {
    throw new Error('called findParent with null id');
  }

  if (parent._id === id) {
    return parent;
  }

  for (var c of parent.children) {
    if (c._id === id) {
      return parent;
    }
    if (c.children) {
      var found = findParent(c, id);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

export const outputTree = (store, parent, level, property) => {
  for (var c of parent) {
    var title = c.type === 'Part' ? store.state.parts[c._id].title : store.state.stages[c._id].title;
    var value = '';
    if (property) {
      value = c.type === 'Part' ? store.state.parts[c._id][property] : store.state.stages[c._id][property];
    }
    console.log('  '.repeat(level), title, c.type, c._id, value);
    if (c.children) {
      outputTree(store, c.children, level + 1, property);
    }
  }
};

export const findChildren = (parent, id) => {
  if (!parent) {
    return null;
  }

  for (var c of parent) {
    if (c._id === id) {
      return c.children;
    }
    if (c.children) {
      var found = findChildren(c.children, id);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

export const findChildInTree = (parent, id) => {
  if (parent._id === id) {
    return parent;
  }

  for (var c of parent.children) {
    if (c._id === id) {
      return c;
    }
    if (c.children) {
      var found = findChildInTree(c, id);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

export const indexOfChild = (parent, id) => {
  for (var i = 0; i < parent.length; i++) {
    if (parent[i]._id === id) {
      return i;
    }
  }
  return null;
};

export const findParentDiary = (parent, id) => {
  if (!id) {
    throw new Error('called findParent with null id');
  }

  if (parent._id === id) {
    return parent;
  }

  for (var c of parent.children) {
    if (c._id === id) {
      if (c.part) {
        // console.log(JSON.stringify(parent));
        // console.log(JSON.stringify(c), id);
        return parent;
      }
      if (parent.type === 'Stage') {
        return parent;
      }
    }
    if (c.children) {
      var found = findParentDiary(c, id);
      if (found) {
        return found;
      }
    }
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/common/treeHelpers.js